// 刷新页面
export const reload = () => {
    window.location.reload();
};

// 跳转页面
export const toPage = (url = '', params = {}, isNewTab = false) => {
    const paramsString = qs.stringify(params);
    const href = url + (paramsString ? `?${paramsString}` : '');
    const elmentA = document.createElement('a');
    if (isNewTab) {
        elmentA.target = '_blank';
    }
    elmentA.href = href;
    elmentA.click();
};

// 下载文件
export const download = url => {
    const a = document.createElement('a');
    a.href = url;
    a.download = url;
    a.click();
};

// 水印
export const addWaterMarker = (dom, str) => {
    if (!str) {
        return;
    }
    const can = document.createElement('canvas');
    const div = document.createElement('div');

    can.width = 590;
    can.height = 490;
    can.style.display = 'none';

    const cans = can.getContext('2d');
    cans.rotate((-15 * Math.PI) / 180);
    cans.font = '14px Microsoft JhengHei';
    cans.fillStyle = 'rgba(17, 17, 17, 0.1)';
    cans.textAlign = 'left';
    cans.textBaseline = 'Middle';
    cans.fillText(str, 80, 100);
    cans.fillText(str, 380, 390);

    div.style.cssText = 'position: fixed; top: 0; bottom: 0; left: 0; right: 0; pointer-events: none; z-index: 9999;';
    div.style.backgroundImage = `url(${can.toDataURL('image/png')})`;
    dom.appendChild(can);
    dom.appendChild(div);
};
